/** Holiclay's existing Wix embed loads on all pages, including SPA navigation. */
export function isWidgetPageAllowed(slug: string | null, pathname: string): boolean {
  if (slug !== 'holiclay') return true;
  const path = pathname.replace(/\/+$/, '') || '/';
  return (
    path === '/events' ||
    path.startsWith('/events/') ||
    path === '/teambuilding-nature-rse' ||
    path === '/team-building-entreprise-lille' ||
    path === '/statistiques-teambuilding-cohesion'
  );
}

export function watchPageNavigation(target: Window, refresh: () => void): void {
  for (const name of ['pushState', 'replaceState'] as const) {
    const original = target.history[name];
    target.history[name] = function (...args: Parameters<History[typeof name]>) {
      original.apply(this, args);
      refresh();
    };
  }
  target.addEventListener('popstate', refresh);
  target.addEventListener('hashchange', refresh);
  target.addEventListener('pageshow', refresh);
}
